import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-text-dialog',
    templateUrl: './text-dialog.component.html',
    styleUrls: ['./text-dialog.component.scss'],
    standalone: false,
})
export class TextDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<TextDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            text: string;
            noClickClose: boolean;
            trueButtonText: string;
            falseButtonText: string;
            centerTrueButton?: boolean;
        },
    ) {
        dialogRef.disableClose = !data.noClickClose;
    }

    closeDialogTrue() {
        this.dialogRef.close(true);
    }

    closeDialogFalse() {
        this.dialogRef.close(false);
    }
}
